import React from "react";
import SingleContentPage from "../Shared/SingleContentPage";

const Notice = () => {
  return <SingleContentPage title="Notice" moduleKey="notice" />;
};

export default Notice;
